//Generates a nx3 array
export function fillProductGrid(products: any) {
    const productArray: Array<any> = [];
    for (let i = 0; i < products.length; i += 3)
        productArray.push([products[i], products[i + 1], products[i + 2]]);
    return productArray;
}
